import { H5, H6 } from "@sellar-io/components";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { formatCurrency } from "@sellar-io/common";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { ProfilePicture } from "../../../../../../components";
import { useSignupContext } from "../../../../../../hooks/useSignupContext.shared";
export const StorefrontSignupDialogBasketInfoMobile = ({
  supplier,
  className,
}: {
  supplier?: SupplierGetResponseType;
  className?: string;
}): ReactElement => {
  const { basketTotal } = useSignupContext();
  return (
    <div
      className={twMerge(
        "flex flex-row items-center justify-between rounded-lg bg-zinc-100 p-4",
        className,
      )}
    >
      <div className={"flex flex-row items-center justify-center gap-2"}>
        <ProfilePicture logoUrl={supplier?.Business.logoUrl} size={"medium"} />
        <div className="flex flex-col">
          <H5>{supplier?.Business.name}</H5>
          <H6>
            <small>Order pending </small>
          </H6>
        </div>
      </div>
      <div className="flex flex-col items-end">
        <H5>{formatCurrency(basketTotal ?? 0)}</H5>
        <H6>
          {" "}
          <small>Total (inc. VAT)</small>
        </H6>
      </div>
    </div>
  );
};
